import React, { Component } from "react";
import { Grid, Typography, Card, Select, MenuItem, FormControl, InputLabel, Input, InputAdornment, IconButton, CardContent } from '@material-ui/core';
import AppointmentTimePicker from "../appointment-time-picker/appointment-time-picker";
import ClearIcon from '@material-ui/icons/Clear';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";

import "./assign-engineer.css";

export default class AssignEngineer extends Component {

    onAppointmentDateChange = (event) => {
        this.props.onAssignmentValueChange("appointmentDate", event._d, this.props.assignmentId);
    };

    onAppointmentTimeChange = (event) => {
        this.props.onAppointmentTimeChange(event, this.props.assignmentId);
    };

    onChange = (event) => {
        this.props.onAssignmentValueChange(event.target.name, event.target.value, this.props.assignmentId);
    };

    remove = () => {
        this.props.onRemoveAssignment(this.props.assignmentId);
    };

    render() {
        return (<Card>
            <CardContent>
                <Grid container spacing={2} direction="row">
                    <Grid item xs={12}>
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="engineerId">Engineer</InputLabel>
                            <Select name="engineerId" onChange={this.onChange} value={this.props.engineerId}>
                                {this.props.engineerList?.map((engineer, index) => <MenuItem key={index} value={engineer.id}>{engineer.fullName}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs="auto">
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                        fullWidth
                        disableToolbar
                        variant="inline"
                        format="DD/MM/yyyy"
                        label="Appointment Date"
                        name="appointmentDate"
                        value={this.props.appointmentDate}
                        onChange={this.onAppointmentDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }} />
                </MuiPickersUtilsProvider>
            </Grid>
                    <Grid item xs={6}>
                        <AppointmentTimePicker
                            caption="Appt. Time"
                            name="appointmentTime"
                            timeslot={this.props.timeslot}
                            appointmentTime={this.props.appointmentTime}
                            onChange={this.onAppointmentTimeChange} />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="duration">Duration</InputLabel>
                            <Input
                                type="number"
                                name="duration"
                                endAdornment={<InputAdornment position="end">Hr</InputAdornment>}
                                value={this.props.duration}
                                onChange={this.onChange}
                                InputProps={{
                                    inputProps: {
                                        min: 0,
                                        step: 0.5
                                    }
                                }} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="value">Net Labour Value</InputLabel>
                            <Input
                                required
                                startAdornment={<InputAdornment position="start">£</InputAdornment>}
                                name="value"
                                value={this.props.value}
                                onChange={this.onChange} />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container justify="center">
                    <Grid item xs="auto">
                        <IconButton disabled={!this.props.allowRemove} color="secondary" onClick={this.remove}>
                            <ClearIcon />
                            <Typography variant="button">Remove</Typography>
                        </IconButton>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>);
    }
}